<template>
  <div class="comfirm_reset">
    <h2><img src="../../assets/img/caution.svg" alt="caution">全ての内容をリセットしてもいいですか？</h2>
    <div>
      <button @click="reset()">はい</button>
      <button @click="close()">いいえ</button>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
import CONST from '../../assets/js/const'
const {EDIT_CIRCLE_RADIUS, EDIT_RECT_SIZE} = CONST


export default {
  name: "ComfirmReset",
  computed: {
  },
  methods:{
    ...mapActions('simulator', ["updateItemInfo", "commitTempItem", "resetItemList"]),
    async reset() {
      this.resetItemList();
      this.$emit('closeModal');
      },
    async close() {
      this.$emit('closeModal');
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/define";

.comfirm_reset {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  h2 {
    font-size: clamp(12px, 1.2vw, 20px);
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    img{
      width: 2vw;
      margin-right: 10px;
    }
  }
  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 50%;
    width: 100%;
    margin: 0 auto;
    button {
      font-size: clamp(10px, 1.2vw, 20px);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: 0.3s;
      padding: 5px 15px;
      width: calc(50% - 25px);
      border:1px solid #000;
      border-radius: 3px;
    }
    button:first-child{
      background-color: #000;
      color: #fff;
    }
    button:last-child{
      background-color: #fff;
      color: #000;
    }
    button:first-child:hover{
      background-color: red;
      border:1px solid red;
    }
  }
}
</style>
